import React from 'react';
import { ShieldIcon, SearchIcon, FilterIcon, FileTextIcon } from 'lucide-react';
export const Audit: React.FC = () => {
  return <div className="space-y-4" data-id="element-1640">
      <div className="flex items-center justify-between mb-4" data-id="element-1641">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-1642">
          <ShieldIcon size={24} className="mr-2" data-id="element-1643" />
          Audit & Kepatuhan
        </h1>
        <div className="flex space-x-2" data-id="element-1644">
          <button className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" data-id="element-1645">
            Ekspor Log
          </button>
          <button className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium" data-id="element-1646">
            Generate Laporan
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1647">
        <div className="p-4 border-b border-gray-200 flex flex-wrap gap-3 items-center justify-between" data-id="element-1648">
          <div className="relative flex-grow max-w-md" data-id="element-1649">
            <input type="text" placeholder="Cari log audit..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-1650" />
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1651" />
          </div>
          <div className="flex items-center gap-2" data-id="element-1652">
            <button className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200" data-id="element-1653">
              <FilterIcon size={16} className="mr-1" data-id="element-1654" />
              Filter
            </button>
            <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-1655">
              <option value="" data-id="element-1656">Tipe Aksi</option>
              <option value="create" data-id="element-1657">Create</option>
              <option value="update" data-id="element-1658">Update</option>
              <option value="delete" data-id="element-1659">Delete</option>
              <option value="login" data-id="element-1660">Login</option>
              <option value="export" data-id="element-1661">Export</option>
            </select>
            <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-1662">
              <option value="" data-id="element-1663">Unit</option>
              <option value="setuma" data-id="element-1664">Setuma</option>
              <option value="deputi" data-id="element-1665">Deputi</option>
              <option value="stin" data-id="element-1666">STIN</option>
              <option value="binda" data-id="element-1667">BINDA</option>
            </select>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1668">
          <table className="w-full" data-id="element-1669">
            <thead className="bg-neutral-light" data-id="element-1670">
              <tr data-id="element-1671">
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1672">
                  Waktu
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1673">
                  Pengguna
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1674">
                  IP Address
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1675">
                  Aksi
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1676">
                  Objek
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1677">
                  Unit
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1678">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1679">
                  Detail
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1680">
              <tr className="hover:bg-neutral-light" data-id="element-1681">
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1682">
                  2023-08-10 08:45:12
                </td>
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1683">
                  Ahmad Supriyadi
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1684">10.45.12.8</td>
                <td className="px-4 py-3 text-sm" data-id="element-1685">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1686">
                    Login
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1687">System</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1688">Setuma</td>
                <td className="px-4 py-3 text-sm" data-id="element-1689">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1690">
                    Success
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1691">
                  <button className="text-accent-info hover:underline" data-id="element-1692">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-1693">
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1694">
                  2023-08-10 09:12:45
                </td>
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1695">
                  Ahmad Supriyadi
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1696">10.45.12.8</td>
                <td className="px-4 py-3 text-sm" data-id="element-1697">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-1698">
                    Update
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1699">
                  AST-001 (Server Database Utama)
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1700">Setuma</td>
                <td className="px-4 py-3 text-sm" data-id="element-1701">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1702">
                    Success
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1703">
                  <button className="text-accent-info hover:underline" data-id="element-1704">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-1705">
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1706">
                  2023-08-10 10:05:33
                </td>
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1707">
                  Budi Santoso
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1708">10.87.22.15</td>
                <td className="px-4 py-3 text-sm" data-id="element-1709">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1710">
                    Login
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1711">System</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1712">STIN</td>
                <td className="px-4 py-3 text-sm" data-id="element-1713">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1714">
                    Success
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1715">
                  <button className="text-accent-info hover:underline" data-id="element-1716">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-1717">
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1718">
                  2023-08-10 10:18:22
                </td>
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1719">
                  Budi Santoso
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1720">10.87.22.15</td>
                <td className="px-4 py-3 text-sm" data-id="element-1721">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800" data-id="element-1722">
                    Export
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1723">
                  Laporan Aset STIN
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1724">STIN</td>
                <td className="px-4 py-3 text-sm" data-id="element-1725">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1726">
                    Success
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1727">
                  <button className="text-accent-info hover:underline" data-id="element-1728">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-1729">
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1730">
                  2023-08-10 11:05:48
                </td>
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1731">
                  Hendra Wijaya
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1732">
                  103.45.67.89
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1733">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1734">
                    Login
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1735">System</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1736">Itjen</td>
                <td className="px-4 py-3 text-sm" data-id="element-1737">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-1738">
                    Failed
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1739">
                  <button className="text-accent-info hover:underline" data-id="element-1740">
                    View
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light bg-red-50" data-id="element-1741">
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1742">
                  2023-08-10 11:07:12
                </td>
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1743">
                  Hendra Wijaya
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1744">
                  103.45.67.89
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1745">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1746">
                    Login
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1747">System</td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1748">Itjen</td>
                <td className="px-4 py-3 text-sm" data-id="element-1749">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-1750">
                    Warning
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-1751">
                  <button className="text-accent-info hover:underline" data-id="element-1752">
                    View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-between" data-id="element-1753">
          <div className="text-sm text-gray-700" data-id="element-1754">
            Menampilkan 6 dari 1,254 log audit
          </div>
          <div className="flex items-center space-x-2" data-id="element-1755">
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50" data-id="element-1756">
              Sebelumnya
            </button>
            <button className="px-3 py-1 bg-secondary text-white rounded-md text-sm" data-id="element-1757">
              1
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-1758">
              2
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-1759">
              3
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm" data-id="element-1760">
              Berikutnya
            </button>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-1761">
        <div className="lg:col-span-2 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1762">
          <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-1763">
            <h2 className="font-bold text-secondary" data-id="element-1764">Detail Log Audit</h2>
          </div>
          <div className="p-4" data-id="element-1765">
            <div className="bg-red-50 border border-red-200 p-3 rounded-lg mb-4" data-id="element-1766">
              <div className="flex items-center justify-between mb-2" data-id="element-1767">
                <h3 className="font-medium text-secondary" data-id="element-1768">Login Warning</h3>
                <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full" data-id="element-1769">
                  Warning
                </span>
              </div>
              <div className="space-y-2 text-sm" data-id="element-1770">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-1771">
                  <div data-id="element-1772">
                    <p className="text-xs text-gray-500" data-id="element-1773">Waktu</p>
                    <p className="text-sm" data-id="element-1774">2023-08-10 11:07:12</p>
                  </div>
                  <div data-id="element-1775">
                    <p className="text-xs text-gray-500" data-id="element-1776">Pengguna</p>
                    <p className="text-sm" data-id="element-1777">Hendra Wijaya (hwijaya)</p>
                  </div>
                  <div data-id="element-1778">
                    <p className="text-xs text-gray-500" data-id="element-1779">IP Address</p>
                    <p className="text-sm" data-id="element-1780">103.45.67.89</p>
                  </div>
                  <div data-id="element-1781">
                    <p className="text-xs text-gray-500" data-id="element-1782">Lokasi</p>
                    <p className="text-sm" data-id="element-1783">Bandung (Tidak Biasa)</p>
                  </div>
                </div>
                <div className="pt-2 border-t border-red-200" data-id="element-1784">
                  <p className="text-xs text-gray-500" data-id="element-1785">Deskripsi</p>
                  <p className="text-sm" data-id="element-1786">
                    Login berhasil tetapi dari lokasi yang tidak biasa. User
                    biasanya login dari Jakarta (10.45.xx.xx).
                  </p>
                </div>
                <div className="pt-2 border-t border-red-200" data-id="element-1787">
                  <p className="text-xs text-gray-500" data-id="element-1788">Tindakan Sistem</p>
                  <p className="text-sm" data-id="element-1789">
                    OTP verifikasi kedua dikirimkan. Verifikasi berhasil.
                    Session dibatasi 1 jam.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-gray-200 p-3 rounded-lg" data-id="element-1790">
              <h3 className="font-medium text-secondary mb-2" data-id="element-1791">
                Timeline Aktivitas User
              </h3>
              <div className="relative" data-id="element-1792">
                <div className="absolute left-2 top-0 bottom-0 w-0.5 bg-gray-200" data-id="element-1793"></div>
                <div className="space-y-4" data-id="element-1794">
                  <div className="relative pl-8" data-id="element-1795">
                    <div className="absolute left-0 w-4 h-4 bg-yellow-500 rounded-full border-4 border-white" data-id="element-1796"></div>
                    <div className="text-xs text-gray-500" data-id="element-1797">11:07:12</div>
                    <div className="text-sm" data-id="element-1798">
                      Login berhasil (dengan warning)
                    </div>
                  </div>
                  <div className="relative pl-8" data-id="element-1799">
                    <div className="absolute left-0 w-4 h-4 bg-red-500 rounded-full border-4 border-white" data-id="element-1800"></div>
                    <div className="text-xs text-gray-500" data-id="element-1801">11:05:48</div>
                    <div className="text-sm" data-id="element-1802">Login gagal (password salah)</div>
                  </div>
                  <div className="relative pl-8" data-id="element-1803">
                    <div className="absolute left-0 w-4 h-4 bg-blue-500 rounded-full border-4 border-white" data-id="element-1804"></div>
                    <div className="text-xs text-gray-500" data-id="element-1805">10:45:22</div>
                    <div className="text-sm" data-id="element-1806">Melihat laporan audit Q2 2023</div>
                  </div>
                  <div className="relative pl-8" data-id="element-1807">
                    <div className="absolute left-0 w-4 h-4 bg-green-500 rounded-full border-4 border-white" data-id="element-1808"></div>
                    <div className="text-xs text-gray-500" data-id="element-1809">09:15:33</div>
                    <div className="text-sm" data-id="element-1810">
                      Login berhasil (lokasi normal)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-4" data-id="element-1811">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1812">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-1813">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-1814">
                <FileTextIcon size={18} className="mr-2" data-id="element-1815" />
                Laporan Kepatuhan
              </h2>
            </div>
            <div className="p-4" data-id="element-1816">
              <div className="space-y-3" data-id="element-1817">
                <button className="w-full flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-neutral-light" data-id="element-1818">
                  <div className="flex items-center" data-id="element-1819">
                    <div className="bg-blue-100 p-2 rounded-md mr-3" data-id="element-1820">
                      <FileTextIcon size={18} className="text-blue-600" data-id="element-1821" />
                    </div>
                    <div className="text-left" data-id="element-1822">
                      <h3 className="text-sm font-medium text-secondary" data-id="element-1823">
                        Laporan Audit Q2 2023
                      </h3>
                      <p className="text-xs text-gray-500" data-id="element-1824">Untuk Itjen/BPK</p>
                    </div>
                  </div>
                  <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-1825">
                    Final
                  </span>
                </button>
                <button className="w-full flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-neutral-light" data-id="element-1826">
                  <div className="flex items-center" data-id="element-1827">
                    <div className="bg-blue-100 p-2 rounded-md mr-3" data-id="element-1828">
                      <FileTextIcon size={18} className="text-blue-600" data-id="element-1829" />
                    </div>
                    <div className="text-left" data-id="element-1830">
                      <h3 className="text-sm font-medium text-secondary" data-id="element-1831">
                        Laporan Kepatuhan Aset STIN
                      </h3>
                      <p className="text-xs text-gray-500" data-id="element-1832">Untuk Kepala STIN</p>
                    </div>
                  </div>
                  <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-1833">
                    Final
                  </span>
                </button>
                <button className="w-full flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-neutral-light" data-id="element-1834">
                  <div className="flex items-center" data-id="element-1835">
                    <div className="bg-blue-100 p-2 rounded-md mr-3" data-id="element-1836">
                      <FileTextIcon size={18} className="text-blue-600" data-id="element-1837" />
                    </div>
                    <div className="text-left" data-id="element-1838">
                      <h3 className="text-sm font-medium text-secondary" data-id="element-1839">
                        Laporan Audit Q1 2023
                      </h3>
                      <p className="text-xs text-gray-500" data-id="element-1840">Untuk Itjen/BPK</p>
                    </div>
                  </div>
                  <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-1841">
                    Final
                  </span>
                </button>
                <button className="w-full flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-neutral-light" data-id="element-1842">
                  <div className="flex items-center" data-id="element-1843">
                    <div className="bg-yellow-100 p-2 rounded-md mr-3" data-id="element-1844">
                      <FileTextIcon size={18} className="text-yellow-600" data-id="element-1845" />
                    </div>
                    <div className="text-left" data-id="element-1846">
                      <h3 className="text-sm font-medium text-secondary" data-id="element-1847">
                        Laporan Audit Q3 2023
                      </h3>
                      <p className="text-xs text-gray-500" data-id="element-1848">Untuk Itjen/BPK</p>
                    </div>
                  </div>
                  <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full" data-id="element-1849">
                    Draft
                  </span>
                </button>
              </div>
              <div className="mt-4" data-id="element-1850">
                <button className="w-full bg-secondary text-white py-2 rounded-md hover:bg-opacity-90" data-id="element-1851">
                  Generate Laporan Baru
                </button>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1852">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-1853">
              <h2 className="font-bold text-secondary" data-id="element-1854">Statistik Audit</h2>
            </div>
            <div className="p-4" data-id="element-1855">
              <div className="space-y-3" data-id="element-1856">
                <div data-id="element-1857">
                  <div className="flex justify-between items-center mb-1" data-id="element-1858">
                    <span className="text-xs text-gray-500" data-id="element-1859">
                      LOGIN ATTEMPTS
                    </span>
                    <span className="text-xs font-medium" data-id="element-1860">1,245</span>
                  </div>
                  <div className="h-1.5 w-full bg-gray-200 rounded-full" data-id="element-1861">
                    <div className="h-1.5 bg-green-500 rounded-full" style={{
                    width: '85%'
                  }} data-id="element-1862"></div>
                  </div>
                  <div className="flex justify-between text-xs mt-1" data-id="element-1863">
                    <span className="text-green-600" data-id="element-1864">Success: 1,058</span>
                    <span className="text-red-600" data-id="element-1865">Failed: 187</span>
                  </div>
                </div>
                <div data-id="element-1866">
                  <div className="flex justify-between items-center mb-1" data-id="element-1867">
                    <span className="text-xs text-gray-500" data-id="element-1868">
                      DATA MODIFICATIONS
                    </span>
                    <span className="text-xs font-medium" data-id="element-1869">865</span>
                  </div>
                  <div className="h-1.5 w-full bg-gray-200 rounded-full" data-id="element-1870">
                    <div className="h-1.5 bg-blue-500 rounded-full" style={{
                    width: '65%'
                  }} data-id="element-1871"></div>
                  </div>
                </div>
                <div data-id="element-1872">
                  <div className="flex justify-between items-center mb-1" data-id="element-1873">
                    <span className="text-xs text-gray-500" data-id="element-1874">
                      EXPORT ACTIONS
                    </span>
                    <span className="text-xs font-medium" data-id="element-1875">312</span>
                  </div>
                  <div className="h-1.5 w-full bg-gray-200 rounded-full" data-id="element-1876">
                    <div className="h-1.5 bg-purple-500 rounded-full" style={{
                    width: '25%'
                  }} data-id="element-1877"></div>
                  </div>
                </div>
                <div data-id="element-1878">
                  <div className="flex justify-between items-center mb-1" data-id="element-1879">
                    <span className="text-xs text-gray-500" data-id="element-1880">
                      SECURITY ALERTS
                    </span>
                    <span className="text-xs font-medium" data-id="element-1881">42</span>
                  </div>
                  <div className="h-1.5 w-full bg-gray-200 rounded-full" data-id="element-1882">
                    <div className="h-1.5 bg-red-500 rounded-full" style={{
                    width: '5%'
                  }} data-id="element-1883"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};